<template>
    <section id="conversion-id">
        <div class='o-text-primary u-font-weight-600 mb-2'>Конвертация</div>
        <div class="row g-3 g-md-5">
            <div class="col-12 col-md-6 position-relative">
                <div class='bg_green rounded'>
                    <div class='px-2 px-md-4 py-4'>
                        <div class='mb-4'>
                                <div class="d-flex gap-2">
                                    <img :src="`/static/img/ico/ico-${crypto1?.currency?.code?.toLowerCase()}.png`"
                                        :class="animation ? 'coin-enter-active' : ''" width="32" height="32" />
                                    <select @change="changeCrypto" class="form-select shadow-none border-0 w-auto cursor-pointer"
                                        v-model="crypto1">
                                        <option v-show="crypto2?.id !== item.id" v-for="(item, index) in cryptos" :key="index"
                                            :value="item">
                                            {{ item.currency?.code }}
                                        </option>
                                    </select>
                                    <div class="input-group">
                                        <input type="number" class="form-control border-0 shadow-none" @keyup="calc(1)"
                                            v-model="amountFrom" placeholder='Введите сумму'
                                            :aria-label="`Сумма конвертации ${crypto1?.currency?.code}`"
                                            id="crypto1_amount_conversation">
                                        <button @click="convAllTop"
                                            class="input-group-text bg-white border-0 convAllBtn">max</button>
                                    </div>
                                </div>
                              
                        </div>
                        <div class='d-flex flex-column gap-2'>
                                <div class="row">
                                    <span class="col-5 col-md-4 fs-14">Ваш баланс:</span>
                                    <span class="col fs-14">{{balanceFrom}} {{crypto1?.currency?.code}}</span>
                                </div>
                                <div class="row">
                                    <span class="col-5 col-md-4 fs-14">Будет:</span>
                                    <span class="col fs-14">{{resultBalanceFrom}} {{crypto1?.currency?.code}}</span>
                                </div>
                        </div>
                    </div>
                </div>

                <div class='lk__convert-right pt-3 text-green fw-normal d-none d-md-block'>Комиссия системы <br> за конвертацию — {{findCommission * 100 }}%</div>

                <button @click="swap" class='position-absolute start-100 top-0 translate-middle-x py-4 d-none d-md-block'>
                    <img src='/img/ico/ico-convert--big.svg' />
                </button>
                <button @click="swap" class='position-absolute start-50 top-100 translate-middle pt-3 d-block d-md-none'>
                    <img width="38" height="38" src='/img/ico/ico-convert--big.svg' />
                </button>
            </div>

            <div class="col-12 col-md-6">
                <div class='bg_green rounded'>
                    <div class='px-2 px-md-4 py-4'>
                        <div class='mb-4'>
                                <div class="d-flex gap-2">
                                    <img :src="`/static/img/ico/ico-${crypto2?.currency?.code?.toLowerCase()}.png`" width="32"
                                        height="32" :class="animation ? 'coin-enter-active' : ''" />
                                    <select @change="changeCrypto" class="form-select shadow-none border-0 w-auto cursor-pointer"
                                        v-model="crypto2">
                                        <option v-show="crypto1?.id !== item.id" v-for="(item, index) in cryptos" :key="index"
                                            :value="item">
                                            {{ item.currency?.code }}
                                        </option>
                                    </select>
                                    <div class="input-group">
                                        <input type="number" class="form-control border-0 shadow-none" @keyup="calc(2)"
                                            v-model="amountTo" placeholder='Введите сумму'
                                            :aria-label="`Сумма конвертации ${crypto2?.currency?.code}`"
                                            id="crypto2_amount_conversation">
                                        <button @click="convAllbottom"
                                            class="input-group-text bg-white border-0 convAllBtn">max</button>
                                    </div>
                                </div>
                               
                            </div>
                            <div class='d-flex flex-column gap-2'>
                                <div class="row">
                                    <span class="col-5 col-md-4 fs-14">Ваш баланс:</span>
                                    <span class="col">{{balanceTo}} {{crypto2?.currency?.code}}</span>
                                </div>
                                <div class="row">
                                    <span class="col-5 col-md-4 fs-14">Будет:</span>
                                    <span class="col">{{resultBalanceTo}} {{crypto2?.currency?.code}}</span>
                                </div>
                        </div>
                                
                        </div>

                        <button @click="send" class='button w-100 mw-100 bg_lightgreen mt-auto' :disabled="(!(amountTo > 0) && !(amountFrom > 0)) || (resultBalanceFrom < 0)">Обменять</button>
                    </div>
                </div>
                <div class='fs-14 pt-3 text-green fw-normal d-block d-md-none text-center'>Комиссия системы <br> за конвертацию — {{findCommission * 100 }}%</div>
            </div>
    </section>
</template>
<script>
export default {
    props: ['courses', 'crypto', 'balances', 'myMethods'],
    data() {
        return {
            amountFrom: 0,
            amountTo: 0,
            comission: 0.006,
            crypto1: [],
            crypto2: [],
            animation: false,
        }
    },
    watch: {
        crypto: {
            handler(newCrypto) {
                if (!newCrypto || !Array.isArray(newCrypto)) return;

                // Проверяем параметры из URL
                const urlParams = new URLSearchParams(window.location.search);
                const amount = urlParams.get('amount');
                const currencyFrom = urlParams.get('currencyFrom');
                const currencyTo = urlParams.get('currencyTo');

                if (amount && currencyFrom && currencyTo) {
                    // Находим соответствующие криптовалюты
                    const fromCrypto = newCrypto.find(c => c.currency?.code === currencyFrom);
                    const toCrypto = newCrypto.find(c => c.currency?.code === currencyTo);

                    if (fromCrypto && toCrypto) {
                        this.crypto1 = fromCrypto;
                        this.crypto2 = toCrypto;
                        this.amountFrom = parseFloat(amount).toFixed(this.fixedNumber(fromCrypto.currency.delimiter));
                        // Используем setTimeout для гарантии, что DOM обновился
                        setTimeout(() => {
                            this.calc(1);
                        }, 0);
                    } else {
                        // Если не нашли нужные валюты, используем первые из списка
                        this.crypto1 = newCrypto[0] || null;
                        this.crypto2 = newCrypto[1] || null;
                        this.initializeAmounts();
                    }
                } else {
                    // Стандартная инициализация
                    this.crypto1 = newCrypto[0] || null;
                    this.crypto2 = newCrypto[1] || null;
                    this.initializeAmounts();
                }
            },
            immediate: true
        },
        amountFrom() {
            if (!this.amountFrom) return;
            if (this.amountFrom < 0) this.amountFrom = 0;
        },
        amountTo() {
            if (!this.amountTo) return;
            if (this.amountTo < 0) this.amountTo = 0;
        }
    },
    computed: {
        cryptos() {
            return this.crypto.sort((a, b) => b.currency.code.localeCompare(a.currency.code));
        },
        balanceFrom() {
            return Number(this.balances?.find(b => b.currency?.code == this.crypto1?.currency?.code)?.value / this.crypto1?.currency.delimiter).toFixed(this.fixedNumber(this.crypto1?.currency.delimiter));
        },
        balanceTo() {
            return Number(this.balances?.find(b => b.currency?.code == this.crypto2?.currency?.code)?.value / this.crypto2?.currency.delimiter).toFixed(this.fixedNumber(this.crypto2?.currency.delimiter))
        },
        resultBalanceFrom() {
            return (Number(this.balanceFrom) - Number(this.amountFrom)).toFixed(this.fixedNumber(this.crypto1?.currency.delimiter));
        },
        resultBalanceTo() {
            return (Number(this.balanceTo) + Number(this.amountTo)).toFixed(this.fixedNumber(this.crypto2?.currency.delimiter));
        },
        findCourse() {
            return this.courses?.find(course => course.pair === `${this.crypto1?.currency?.code}-${this.crypto2?.currency?.code}`)?.rate || 1;
        },
        method() {
            return this.myMethods?.find(m =>
                m.currency_from?.code == this.crypto1?.currency?.code &&
                m.currency_to?.code == this.crypto2?.currency?.code &&
                m.payment_operation?.name === "Конвертация"
            );
        },
        findCommission() {
            return this.method?.commission || this.comission;
        }
    },
    methods: {
        fixedNumber(number) {
            return String(number).split('0').length - 1 || 0;
        },
        changeCrypto() {
            this.animation = true;
            this.calc(1);
            setTimeout(() => (this.animation = false), 1000);
        },
        swap() {
            [this.crypto1, this.crypto2] = [this.crypto2, this.crypto1];
            this.amountFrom = this.amountTo;
            this.$nextTick(() => this.calc(1));
        },
        calc(pos) {
            if (pos === 1) {
                if (!this.amountFrom) {
                    this.amountTo = (0).toFixed(this.fixedNumber(this.crypto2.currency.delimiter));
                    return;
                }
                const t = this.amountFrom * this.findCourse;
                const comm = t * this.findCommission;
                this.amountTo = ((t - comm) / this.crypto2.currency.delimiter).toFixed(this.fixedNumber(this.crypto2.currency.delimiter));
            } else if (pos === 2) {
                if (!this.amountTo) {
                    this.amountFrom = (0).toFixed(this.fixedNumber(this.crypto1.currency.delimiter));
                    return;
                }
                // Сначала вычисляем, затем округляем:
                this.amountFrom = ((this.amountTo * this.crypto2.currency.delimiter) /
                    (this.findCourse * (1 - this.findCommission)))
                    .toFixed(this.fixedNumber(this.crypto1.currency.delimiter));
            }
        },
        setErrors(response) {
            const errors = response?.data?.errors || {};
            const mess = response?.data?.message || 'Что-то пошло не так';
            let text = ''
            for (const field in errors) {
                text = errors[field][0];
                break;
            }
            eventBus.$emit('errorBus', text || mess);
        },
        send() {
            if (!this.method?.id) {
                eventBus.$emit('errorBus', 'Конвертация этой пары временно недоступна');
                return;
            }
            let data = {
                payment_method_id: this.method?.id,
                amount: parseFloat(this.amountFrom),
            };
            axios
                .post(this.$api_address + '/operations/conversions', data, {
                    headers: {
                        "Authorization": `Bearer ${localStorage.getItem('user_token')}`,
                    },
                }).then(response => {
                    this.$emit('convert', data);
                    this.amountFrom = parseFloat(0)
                    this.amountTo = parseFloat(0)
                    if (this.$metrika !== undefined) {
                        this.$metrika.reachGoal('convert_success');
                    }
                    eventBus.$emit('errorBus', 'Конвертация прошла успешно!', true);
                }).catch(error => {
                    if (error.response?.status !== 401) {
                        this.setErrors(error.response);
                    }
                    else {
                        eventBus.$emit('logout');
                    }
                })
        },

        convAllTop() {
            const balance = this.balances?.find(b => b.currency.code === this.crypto1.currency.code)?.value;
            if (!balance) return;

            this.amountFrom = (balance / this.crypto1?.currency?.delimiter);
            this.calc(1);
        },
        convAllbottom() {
            const balance = this.balances?.find(b => b.currency.code === this.crypto2.currency.code)?.value;
            if (!balance) return;

            this.amountTo = (balance / this.crypto2?.currency?.delimiter)
            this.calc(2);
        },
        initializeAmounts() {
            if (this.crypto1?.currency?.delimiter) {
                this.amountFrom = (0).toFixed(this.fixedNumber(this.crypto1.currency.delimiter));
            }
            if (this.crypto2?.currency?.delimiter) {
                this.amountTo = (0).toFixed(this.fixedNumber(this.crypto2.currency.delimiter));
            }
        }
    },
    beforeDestroy() {
        // Очищаем URL от параметров конвертации
        const url = new URL(window.location.href);
        url.searchParams.delete('action');
        url.searchParams.delete('amount');
        url.searchParams.delete('currencyTo');
        url.searchParams.delete('currencyFrom');
        window.history.replaceState({}, '', url.pathname);
    }
}
</script>
<style scoped>
.convAllBtn {
    font-size: 14px;
}

.fs-14 {
    font-size: 14px; 
}

/*.no-arrow {
    appearance: none;
    background-image: none;
  }*/

@keyframes coin-flip {
    from {
        transform: rotateY(0deg);
    }

    to {
        transform: rotateY(360deg);
    }
}

.coin-enter-active {
    animation: coin-flip 1s infinite;
}
</style>